import { ITranslationEntry } from '../lang';

export const GA: ITranslationEntry = {
  translations: {
    notifications: 'Fógraí',
    markAllAsRead: 'Marcáil go léir mar a léitear',
    poweredBy: 'Cumhachtaithe ag',
    settings: 'Socruithe',
  },
  lang: 'ga',
};
